import { Transaction } from "./tallyentry-api-model";

export class ViewTallyTransactionsModel {

  public fromDate: Date;
  public toDate: Date;
  public receiptNo: number;
  public amount: number;
  public purpose: string;

  constructor(init?: Partial<ViewTallyTransactionsModel>) { 
    Object.assign(this, init);
  }
}

export class TallyTransactionsListModel {

  public tallyId: number;
  public naration: string;
  public txnDate: string;
  public amount: number;
  public status: string;
  public purpose: string;
  public source: string;
  public transaction: Transaction;
  public ledgerEntries: LedgerEntry[];

  constructor(init?: Partial<TallyTransactionsListModel>) { 
    Object.assign(this, init);
  }
}

export class LedgerEntry {

  public ledgerEntryId: number;
  public amount: number;
  public ledgerHead: LedgerHead;

  constructor(init?: Partial<LedgerEntry>) { 
    Object.assign(this, init);
  }
}

export class LedgerHead {

  public ledgerHeadId: number;
  public name: string;
  public entryType: string;
  public isDeemedPositive: boolean;

  constructor(init?: Partial<LedgerHead>) { 
    Object.assign(this, init);
  }
}